import PropTypes from 'prop-types';

// Not shape but common props
export const formikFormProps = {
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,

  values: PropTypes.object.isRequired,
  touched: PropTypes.object,
  errors: PropTypes.object,

  isValid: PropTypes.bool,
  loading: PropTypes.bool,
};

export const selectOptionsProp = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.oneOfType([ PropTypes.string, PropTypes.number, ]).isRequired,
    label: PropTypes.string.isRequired,
  })
);

export const transactionHistoryShape = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.number.isRequired,
    kind: PropTypes.string.isRequired,
    // vendor: PropTypes.string.isRequired,
    // transfer_id: PropTypes.number.isRequired,
    // transfer_name: PropTypes.string.isRequired,

    transfer_origin_id: PropTypes.number.isRequired,
    transfer_origin_name: PropTypes.string.isRequired,
    bright_pearl_order_id: PropTypes.number.isRequired,
    goods_note_date: PropTypes.string.isRequired,
    sku: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    amount: PropTypes.string.isRequired,
    amount_money: PropTypes.string.isRequired,
  }),
);

// Data used to display information about transactions in a sale report
export const transactionsReportShape = PropTypes.shape({
  user_ids: PropTypes.arrayOf(PropTypes.number),
  report_items: PropTypes.arrayOf( // one item per user/seller
    PropTypes.shape({
      user_id: PropTypes.number.isRequired,
      currency_code: PropTypes.string.isRequired,
      vendor: PropTypes.string.isRequired,
      transaction_history: transactionHistoryShape.isRequired,
      transaction_totals: PropTypes.object,
      transaction_totals_money: PropTypes.array,
    }), // end group_items shape
  )
});

export const selectOptionsShape = PropTypes.arrayOf(
  PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number,]).isRequired,
    label: PropTypes.string.isRequired,
  }).isRequired,
);

export const paginationShape = PropTypes.shape({
  count: PropTypes.number.isRequired,
  last: PropTypes.number,
  next: PropTypes.number,
  prev: PropTypes.number,
  page: PropTypes.number,
});

export const transferShape = PropTypes.shape({
  total_invoice_by_source: PropTypes.shape({
    transaction_history: transactionHistoryShape.isRequired,
    grand_total: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    totals_by_source: PropTypes.arrayOf(PropTypes.shape({
      key: PropTypes.string.isRequired,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      value_money: PropTypes.string.isRequired,
    })),
  }),
});